module.exports = __webpack_public_path__ + "img/Attitüde.b2a4e98d.jpg";